<li class="nav-item" *ngIf="turn != null">
    <a (click)="pause()" class="btn btn-dark me-2"><i class="fa fa-pause" aria-hidden="true"></i> {{ "pauseAction" | language }}</a>
</li>

<li class="nav-item" *ngIf="turn == null && pausedList.length > 0 && !_data.deskStopped">
    <a (click)="openPausedModal()" class="btn btn-success me-2 animated"><i class="fa fa-play" aria-hidden="true"></i> {{ "recoverAction" | language }} <span class="badge rounded-pill text-bg-danger">{{ pausedList.length }}</span></a>
</li>

<app-modal [id]="'pausedModal'">
    <span modal-title>{{ "recoverAction" | language }}</span>
    <div modal-body>
        <div class="scrolled">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col" *ngIf="_data.session['queuemode'] != 'Q'">{{ "hour" | language }}</th>
                        <th scope="col">{{ "turn" | language }}</th>
                        <th scope="col">{{ "preEvaluation" | language }}</th>
                        <th scope="col">{{ "attentionDate" | language }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let p of pausedList">
                        <td><button (click)="recovery(p.id)" class="btn btn-sm btn-success rounded-circle" [title]="'recoverTurn' | language"><i class="fa fa-play"></i></button></td>
                        <td *ngIf="_data.session['queuemode'] != 'Q'"></td>
                        <td>{{ p.label }}</td>
                        <td>{{ p.prekindname }}</td>
                        <td>{{ p.deskdatetime }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</app-modal>
